(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["events-list-mab"] && !Shopify.designMode) return;
  try {
    
  /* Filter chips for the events list.
     On each chip click:
       1. Set aria-pressed on chips.
       2. Choose the on-view region's drawing: the band, or the standing note.
       3. Hide/show li.event-row[data-event-type] rows in both lists.
       4. Show the upcoming empty-state when a filter hides all upcoming rows.
       5. Announce the visible count (upcoming + archive) to the live region.
       6. Bring the results into view when the filter left them off the screen.
     With JS off every row is visible — progressive enhancement. */
  (function () {
    const container = document.querySelector('[data-events-filter]');
    if (!container) return;

    const chips          = Array.from(container.querySelectorAll('[data-filter]'));
    const countEl        = container.querySelector('[data-events-count]');
    const template       = container.dataset.template || '';
    const upcomingRows   = Array.from(document.querySelectorAll('[data-events-list="upcoming"] li.event-row'));
    const archiveRows    = Array.from(document.querySelectorAll('[data-events-list="archive"] li.event-row'));
    const emptyUpcoming  = document.querySelector('[data-events-empty-upcoming]');
    const onviewRegion   = document.querySelector('[data-onview]');
    const onviewBands    = Array.from(document.querySelectorAll('[data-onview] .events-list__feature'));
    const reduceMotion   = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Which chips the band is part of the answer to. Read from the bands themselves rather than
       named here, so a second on-view type never needs this script changed. */
    const onviewTypes = new Set(onviewBands.map(function (band) {
      return band.dataset.eventType || '';
    }));

    function setCount(n) {
      if (!countEl) return;
      /* Clear then set so aria-live fires reliably even when the text is the same. */
      countEl.textContent = '';
      requestAnimationFrame(function () {
        countEl.textContent = template.replace('%d', n);
      });
    }

    /* The exhibition on view stays on the page under every chip, but it is only the
       band while it is part of what the visitor asked for: "all", or its own type. Under any
       other chip it becomes the standing note, which says what is on view without taking the
       fold the visitor came to read. */
    function setOnView(handle) {
      if (!onviewRegion) return;
      const isPartOfAnswer = handle === 'all' || onviewTypes.has(handle);
      onviewRegion.classList.toggle('events-list__onview--collapsed', !isPartOfAnswer);
    }

    /* The first thing the chip changed: a visible upcoming row, the empty-state that stands in
       for all of them, or — when only archived events match — the first archive row. Elements
       inside a closed <details> report no client rects, so they are not offered as a target. */
    function firstResult() {
      for (const row of upcomingRows) {
        if (row.getClientRects().length) return row;
      }
      if (emptyUpcoming && emptyUpcoming.getClientRects().length) return emptyUpcoming;
      for (const row of archiveRows) {
        if (row.getClientRects().length) return row;
      }
      return null;
    }

    /* Put the control and its effect in one view — and only when they are not already there. The
       chips are the anchor rather than the first result, so the control that produced the change
       stays on screen beside it.

       Two tests, and both are needed. A result whose top edge is above the viewport belongs to a
       visitor who has scrolled down to read: their rows update under them and nothing moves.
       Below that edge, a result has arrived when the fold does not cut it, or when it is long
       enough that half a viewport of it is on screen. A row whose first pixels clear the fold has
       not arrived, and that is the state a chip pressed at the top of the page leaves on a phone.
       Erring towards the scroll is deliberate: an extra scroll shows more of the answer, while a
       missing one leaves the answer cut. */
    function revealResults() {
      const target = firstResult();
      if (!target) return;

      const viewport = document.documentElement.clientHeight;
      const box = target.getBoundingClientRect();
      if (box.top <= 0) return;
      if (box.bottom <= viewport) return;

      const onScreen = viewport - box.top;
      if (onScreen >= viewport / 2) return;

      /* 'instant', not 'auto': 'auto' defers to CSS, and the theme sets scroll-behavior: smooth on
         the document, so a visitor who asked for less motion would still get the animation. */
      container.scrollIntoView({
        behavior: reduceMotion.matches ? 'instant' : 'smooth',
        block: 'start'
      });
    }

    function applyFilter(handle) {
      let visibleUpcoming = 0;
      let visibleArchive  = 0;

      setOnView(handle);

      for (const row of upcomingRows) {
        const show = handle === 'all' || (row.dataset.eventType || '') === handle;
        /* display:none removes the row from layout and from the accessibility tree. */
        row.style.display = show ? '' : 'none';
        if (show) visibleUpcoming += 1;
      }
      for (const row of archiveRows) {
        const show = handle === 'all' || (row.dataset.eventType || '') === handle;
        row.style.display = show ? '' : 'none';
        if (show) visibleArchive += 1;
      }

      /* Show or hide the upcoming empty-state paragraph. */
      if (emptyUpcoming) {
        emptyUpcoming.style.display = (visibleUpcoming === 0) ? '' : 'none';
      }

      setCount(visibleUpcoming + visibleArchive);
    }

    for (const chip of chips) {
      chip.addEventListener('click', function () {
        for (const c of chips) {
          c.setAttribute('aria-pressed', 'false');
          c.classList.remove('is-active');
        }
        chip.setAttribute('aria-pressed', 'true');
        chip.classList.add('is-active');
        applyFilter(chip.dataset.filter || 'all');
        revealResults();
      });
    }

    /* Initialise count to total visible on page load. */
    setCount(upcomingRows.length + archiveRows.length);
    /* The count stays visually hidden and remains a live region. Drawn on the page it was
       decoration — a number nobody came for, competing with the chips it belongs to. Announced,
       it is the only thing that tells a screen reader user their filter did something. */
  }());

  /* Archive closed by default on mobile.
     17 rows open on first paint makes the agenda page feel endless on a phone; the visitor
     can expand the archive by tapping the summary. The threshold 750 matches the theme's
     tablet breakpoint. With JS off the archive stays open — progressive enhancement. */
  (function () {
    if (window.innerWidth >= 750) return;
    var archive = document.querySelector('.events-list__archive');
    if (archive) archive.removeAttribute('open');
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-mab"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-story-mab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-story-mab__more');
    if (!button) return;
    const grid = document.getElementById(button.getAttribute('aria-controls'));
    if (!grid) return;
    grid.setAttribute('data-expanded', '');
    button.setAttribute('aria-expanded', 'true');
    const revealed = grid.querySelectorAll('.product-story-mab__beat')[1];
    revealed?.setAttribute('tabindex', '-1');
    revealed?.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();
})();
